<template>
  <div class="jst-erp-scene">
    <StepPlayer
      ref="player"
      :steps="scenario.steps"
      :initial-step-id="scenario.initialStepId"
      :initial-form="scenario.initialForm"
      :show-tip="false"
      @step-change="onStepChange"
      @guard-failed="onGuardFailed"
      @finish="onFinish"
    />
  </div>
</template>

<script>
import StepPlayer from '@/components/simulate/StepPlayer.vue'
import { getJstErpOrderQueryScenario } from './jstErpOrderQueryScenarios'

export default {
  name: 'JstErpOrderQueryScene',
  components: { StepPlayer },
  data() {
    return { scenario: getJstErpOrderQueryScenario() }
  },
  methods: {
    onStepChange(stepId, step, resolvedTip) {
      this.$emit('step-change', stepId, step, resolvedTip)
    },
    onGuardFailed(res) {
      this.$emit('guard-failed', res)
    },
    onFinish(payload) {
      this.$emit('finish', payload)
    },
    reset() {
      const player = this.$refs.player
      if (player) player.reset(this.scenario.initialStepId)
    }
  }
}
</script>

<style lang="less" scoped>
.jst-erp-scene { width: 100%; min-width: 0; min-height: 100%; color: #303133; text-align: left; background: #fff; }
/deep/ .step-player { display: block; width: 100%; }
/deep/ .step-player .stage { width: 100%; min-height: 420px; overflow: hidden; background-color: #eef2f7; }
/deep/ .step-player .hotspot { z-index: 3; }
/deep/ .step-player .field { z-index: 4; border-radius: 2px; }
/deep/ .step-player .field-input { color: #303133; background: rgba(255, 255, 255, .01); }
</style>



// WEBPACK FOOTER //
// ./src/page/simulate/jushuitan/JstErpOrderQueryScene.vue